export default __webpack_public_path__ + "static/media/sticker-p.5a7fcc95.png";